import { createFileRoute } from '@tanstack/react-router'

import type { PokerSiteDetailResponse } from '@/api/gen'
import { dealPokerSitesRetrieve, getDealPokerSitesRetrieveQueryKey } from '@/api/gen'
import { Loader } from '@/components/loader'
import { buildPageTitle } from '@/utils/seo'

export const Route = createFileRoute('/_layout/_private/app/deals/$room')({
  pendingComponent: Loader,
  loader: async ({ params, context: { queryClient } }) => {
    try {
      const cachedData = queryClient.getQueryData<PokerSiteDetailResponse>(
        getDealPokerSitesRetrieveQueryKey(params.room),
      )

      if (cachedData !== undefined) {
        return cachedData
      }

      const result = await queryClient.fetchQuery({
        queryKey: getDealPokerSitesRetrieveQueryKey(params.room),
        queryFn: () => dealPokerSitesRetrieve(params.room),
        staleTime: 1000 * 60 * 5,
        gcTime: 1000 * 60 * 10,
      })

      return result
    } catch (error) {
      console.error('Failed to fetch deal poker sites', error)
      throw error
    }
  },
  head: ({ loaderData }) => {
    const title = `${loaderData?.name ?? ''} Deals`

    return {
      meta: [
        {
          title: buildPageTitle(title),
        },
      ],
    }
  },
})
